import log from 'loglevel';
import { isAborted, AbortError } from 'hooks/requests/fetchUtils';

/**
 * Convenient method to rethrow the error if it is not one of the given types in
 * promises' catch.
 *
 * If the error is an AbortError (or a DOMError with AbortError name), we
 * assume it was simply rejected and the error has already been handled.
 *
 */
export default function catchOnly(
  error: Error,
  ...errorClasses: Function[]
): boolean {
  // We'll also swallow aborted error here.
  // This error generally doesn't need to be handle. It tends to indicate a new
  // request has been started, or that the component was unmounted whil a
  // request is ongoing. If we start needing to handle AbortError, we can make
  // components explicitly accept this error.
  if (error instanceof AbortError || isAborted(error)) {
    return false;
  }
  const match = errorClasses.find(klass => error instanceof klass);
  if (match !== undefined) {
    return true;
  }
  log.error(error.name, error);
  throw error;
}
